import { FC, useEffect } from "react";
import styles from "./styles.module.css";
import Banner from "./components/Banner";
import Explore from "./components/Explore";
import Partner from "./components/Partner";
import ExploreAndBuild from "./components/ExploreAndBuild";
import Infrastructure from "./components/Infrastructure";
// import RecentUpdate from "./components/RecentUpdate";
import RebakedProject from "./components/RebakedProject";

const LandingPage: FC = () => {
  return (
    <main className={styles.content}>
      <Banner />
      <Explore />
      <Partner />
      <ExploreAndBuild />
      <Infrastructure />
      {/* <RecentUpdate /> */}
      <RebakedProject />
    </main>
  );
};

export default LandingPage;
